<template lang="html">
  <error-page-layout
    color-type="error"
    error-type="Erro 404"
    first-message="O conteúdo que você está buscando não existe."
    icon="cancel"
    image-name="404.png"
    second-message="Confira o endereço digitado ou volte para a Home."
    title="Não achou o que buscava?"
  >
    <v-btn slot="buttons" color="orange" dark text>Voltar para a home</v-btn>
  </error-page-layout>
</template>

<script>
import ErrorPageLayout from '@/components/ErrorPageLayout.vue'
export default {
  components: {
    ErrorPageLayout,
  },
}
</script>
